import { Component, input, signal, ChangeDetectionStrategy } from '@angular/core';
import { BillingPeriod } from '@eadsysteme/billingclient-v1';
import { TranslocoDirective } from '@jsverse/transloco';
import { PeriodSettingsComponent } from './period-settings/period-settings.component';

@Component({
	selector: 'vex-basic-data',
	imports: [TranslocoDirective, PeriodSettingsComponent],
	templateUrl: './basic-data.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './basic-data.component.scss',
})
export class BasicDataComponent {
	billingId = input('');
	periods = input<BillingPeriod[]>([]);
	selectedTabIndex = signal(0);
}
